import { render, staticRenderFns } from "./GroupesList.vue?vue&type=template&id=288d273d&"
import script from "./GroupesList.vue?vue&type=script&lang=js&"
export * from "./GroupesList.vue?vue&type=script&lang=js&"
import style0 from "./GroupesList.vue?vue&type=style&index=0&id=288d273d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports